import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { OwaDate, getTimestamp } from 'owa-datetime';

export default function isItemBetweenDates(
    item: CalendarEvent,
    from: OwaDate,
    to: OwaDate
): boolean {
    /* 	Return true if:
     *  1. start of the item falls between the from and to of the current week
     *  2. end of the items falls between the from and to of the current week
     *  3. item starts before this week and ends after this week
     */
    let fromTime = getTimestamp(from);
    let toTime = getTimestamp(to);
    let itemStart = getTimestamp(item.Start);
    let itemEnd = getTimestamp(item.End);
    return (
        (itemStart >= fromTime && itemStart < toTime) ||
        (itemEnd > fromTime && itemEnd <= toTime) ||
        (itemStart <= fromTime && itemEnd >= toTime)
    );
}
